import { render, staticRenderFns } from "./PopupAboutProfile.vue?vue&type=template&id=e4b7c79e&scoped=true&"
import script from "./PopupAboutProfile.vue?vue&type=script&lang=js&"
export * from "./PopupAboutProfile.vue?vue&type=script&lang=js&"
import style0 from "./PopupAboutProfile.vue?vue&type=style&index=0&id=e4b7c79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b7c79e",
  null
  
)

export default component.exports